/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlaystationTriangle = createReactComponent(
  "playstation-triangle",
  "IconPlaystationTriangle",
  [
    [
      "path",
      {
        d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M7.5 15h9l-4.5 -8z", key: "svg-1" }]
  ]
);

export { IconPlaystationTriangle as default };
//# sourceMappingURL=IconPlaystationTriangle.js.map
